import { v4 as uuid } from 'uuid';
const AUTH_TOKEN = 'AUTH_TOKEN';
const MS_AUTH_TOKEN = 'MS_AUTH_TOKEN';
const REFRESH_TOKEN = 'REFRESH_TOKEN';
const BROWSER_SESSION_ID = 'BROWSER_SESSION_ID';
const setAccessToken = (token) => {
    localStorage.setItem(AUTH_TOKEN, token);
};
const setMSAccessToken = (token) => {
    localStorage.setItem(MS_AUTH_TOKEN, token);
};
const setRefreshToken = (token) => {
    localStorage.setItem(REFRESH_TOKEN, token);
};
const setBrowserSessionId = (browser_id) => {
    localStorage.setItem(BROWSER_SESSION_ID, browser_id);
};
const getAccessToken = () => {
    return localStorage.getItem(AUTH_TOKEN);
};
const getMSAccessToken = () => {
    return localStorage.getItem(MS_AUTH_TOKEN);
};
const getRefreshToken = () => {
    return localStorage.getItem(REFRESH_TOKEN);
};
const getBrowserSessionId = () => {
    const browserId = localStorage.getItem(BROWSER_SESSION_ID);
    if (browserId === null || browserId === undefined || browserId === '') {
        const guid = uuid();
        localStorage.setItem(BROWSER_SESSION_ID, guid);
        return guid;
    }
    else {
        return browserId;
    }
};
const removeAccessToken = () => {
    localStorage.removeItem(AUTH_TOKEN);
};
const removeMSAccessToken = () => {
    localStorage.removeItem(MS_AUTH_TOKEN);
};
const removeRefreshToken = () => {
    localStorage.removeItem(REFRESH_TOKEN);
};
const removeBrowserSessionId = () => {
    localStorage.removeItem(BROWSER_SESSION_ID);
};
const LocalStorageService = {
    setAccessToken,
    setMSAccessToken,
    setRefreshToken,
    setBrowserSessionId,
    getAccessToken,
    getMSAccessToken,
    getRefreshToken,
    getBrowserSessionId,
    removeAccessToken,
    removeMSAccessToken,
    removeRefreshToken,
    removeBrowserSessionId
};
export default LocalStorageService;
